export const features = {
  feeCategorySpendMapping: false,
  programAdjustment: true,
  showGraceDaysFilter: true,
  copyRebateFromAnyRebate: true,
  showHistoricalMonthlyBreakupTab: true,
  showProgramLevelAggregateTable: true,
  workflowRoleExport: true,
  hiddenLinks: ['portfolioPerformance', 'supplierAnalystics','SelfService','fileSharing','addNewProfile'],
  hiddenLandingPageOptions: ['portfolioPerformance', 'supplierAnalytics'],
};
